import { breakingHeadlines } from "../content";

export default function BreakingBar() {
  const doubled = [...breakingHeadlines, ...breakingHeadlines];
  return (
    <div className="relative z-30 border-b border-primary-800 bg-primary-600 text-background-50">
      <div className="flex w-full items-stretch overflow-hidden">
        <span className="z-10 flex shrink-0 items-center gap-1.5 bg-primary-800 px-3 py-2 text-xs font-bold tracking-wider whitespace-nowrap md:px-4">
          <i className="ri-alarm-warning-fill text-sm" />
          突发
        </span>
        <div className="relative flex flex-1 items-center overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-10 whitespace-nowrap py-2">
            {doubled.map((h, i) => (
              <span
                key={i}
                className="flex items-center gap-2 text-sm text-background-50/95"
              >
                <i className="ri-flashlight-fill text-xs text-accent-300" />
                {h}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center bg-primary-800 px-4 text-xs text-background-50/90 sm:flex">
          更新于 08-28
        </span>
      </div>
    </div>
  );
}